import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';

const TooltipWrapper = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? <ReactTooltip className="r-tooltip" /> : null;
};

export default TooltipWrapper;